<template>
  <div class="maindivnew">
    <div class="maindivcontent">
      <el-carousel height="270px" class="lunboimg" :interval="5000" arrow="always">
        <el-carousel-item v-for="(item,index) in imgdata" :key="item.imgname">
          <a target="_blank" :href="item.imgurl">
            <img class="imgdiv" :src="baseUrl.hbjx+'/upload/homeimg/'+item.imgname" alt="">
          </a>
        </el-carousel-item>
      </el-carousel>
      <div class="page">
        <div style="width: 100%;min-height: 1290px;">
          <div v-for="(item,index) in dataList" :key="item.id"  class="itemcontent">
            <div class="title">
              <a target="_blank" :href="item.url">{{item.title}}</a>
            </div>
            <div class="remarks">
              {{item.remark}}
            </div>
            <div class="time">{{dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
            <img v-if="item.isTop=='1'" class="zhidingimg" src="../assets/zhiding.png" alt="">
          </div>
        </div>
       
        <div class="paginationdiv">
          <el-pagination class="pagefy" :total="total" :current-page="pageNumber" :page-size="pageSize"
              :page-sizes="[10, 20, 30, 50]" @current-change="handleCurrentChange" @size-change="handleSizeChange"
              background layout="total, sizes, prev, pager, next"></el-pagination>
      </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        imgdata: [],
        total: 0,
        dataList: [],
        pageNumber: 1,
        pageSize: 10,
      }
    },
    mounted() {
      this.getdata();
      this.getdataList();
    },
    methods: {
      //获取列表数据
      getdataList() {
        axios.get(this.baseUrl.hbjx + '/activities/loadPageByPramas', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            pageNum: this.pageNumber,
            pageSize: this.pageSize,
          }
        })
          .then((res) => {
            this.total = res.data.total;
            this.dataList = res.data.list;
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      getdata() {
        axios.get(this.baseUrl.hbjx + '/upload/homeimg/imgdata.txt', {  //params参数必写 , 如果没有参数传{}也可以
          params: {}
        })
          .then((res) => {
            this.imgdata = res.data;
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getdataList();
      },
      handleCurrentChange(val) {
        this.pageNumber = val;
        this.getdataList();
      },
    }
  }
</script>
<style scoped>
  .maindivcontent {
    width: 825px;
  }

  .maindivnew {
    width: 100;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .paginationdiv {
        display: flex;
        height: 100px;
        align-items: center;
        width: 100%;
        justify-content: center;
        border-top: 1px dashed rgb(233, 230, 230);
    }
  .zhidingimg {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 0px;
    top: 0px;
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  }

  .lunboimg {
    margin-top: 5px;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
  }

  .imgdiv {
    width: 825px;
    height: 270px;

  }

  .title {
    font-size: 16px;
    font-weight: bold;
  }

  .remarks {
    font-size: 15px;
    margin: 10px 0px;
    line-height: 23px;
  }

  .time {
    width: 100%;
    text-align: right;
    padding-right: 10px;
    color: rgb(150, 147, 147);
  }

  .itemcontent {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    border-bottom: 1px dashed rgb(227, 225, 225);
    position: relative;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
    margin: 5px 0px 5px 0px;
    padding: 1em 0 2em;
    background-color: #fff;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
  }
</style>


// WEBPACK FOOTER //
// src/components/HomePage.vue